import { AlertTriangle, ArrowRight, OctagonX } from 'lucide-react';

import { useDieuHuong } from '../../../hooks/useDuongDan';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { useTenantCuaToi } from '../../auth/hooks/useTenantCuaToi';
import { useHanMucTokenAi } from '../../tenant/hooks/useHanMucTokenAi';
import { hienPhanTram, mucToken } from '../../tenant/nghiep-vu/han-muc-token';
import { useLaQuanTriToChuc } from '../hooks/useTokenAi';

/**
 * Dải một dòng ở Dashboard, chỉ hiện khi quản trị tổ chức cần làm gì đó: từ 80% hoặc đã chặn. Số liệu đầy đủ ở thẻ
 * Token AI của màn Báo cáo; bình thường Dashboard không nói gì về token. Tải lỗi thì im: lỗi đã có màn riêng nói.
 */
export function CanhBaoTokenDashboard() {
  const { t, locale } = useT();
  const dieuHuong = useDieuHuong();
  const laQuanTri = useLaQuanTriToChuc();
  const { tenantId } = useTenantCuaToi();
  const q = useHanMucTokenAi(laQuanTri ? tenantId : undefined);
  const d = q.data;
  const muc = d ? mucToken(d) : null;
  if (!laQuanTri || !d || (muc !== 'da-chan' && muc !== 'canh-bao')) return null;

  const chan = muc === 'da-chan';
  const Icon = chan ? OctagonX : AlertTriangle;
  return (
    <div
      role={chan ? 'alert' : 'status'}
      className={
        chan
          ? 'col-span-12 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded-lg border border-danger-200 bg-danger-50 px-4 py-2.5'
          : 'col-span-12 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded-lg border border-warning-200 bg-warning-50 px-4 py-2.5'
      }
    >
      <span className={chan ? 'flex min-w-0 items-center gap-2 text-sm text-danger-700' : 'flex min-w-0 items-center gap-2 text-sm text-warning-700'}>
        <Icon size={16} aria-hidden className="shrink-0" />
        {chan
          ? t('hanMucToken.toChucDaChanTieuDe')
          : hienPhanTram(d.used_percent).vuot
            ? t('manTokenAi.dashboardVuot')
            : t('manTokenAi.dashboardCanhBao', { so: soVN(d.used_percent ?? 0, locale) })}
      </span>
      <button
        type="button"
        onClick={() => dieuHuong('/bao-cao?the=token-ai')}
        className="flex shrink-0 items-center gap-1 text-sm font-medium text-content-primary underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
      >
        {t('manTokenAi.dashboardXem')}
        <ArrowRight size={14} aria-hidden />
      </button>
    </div>
  );
}
